import { useMutation } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { resend_invite } from "../../services/admin";


const  useResendInviation = () => {
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((id)=>resend_invite(id), {
      onSuccess: data => {
        set_success('Successfully resent the invitation!')
        setTimeout(() => {
          set_success('')
        }, 4000);
      },
      onError: () => {
        set_error('Problem resending the invitation email!')
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useResendInviation;